import { ConnectedPosition } from '@angular/cdk/overlay';

export type PositionType = 'above' | 'below' | 'left' | 'right';

export function getChatBotOverlayPosition(position: 'above' | 'below' | 'left' | 'right' = 'below'): ConnectedPosition {
  const positions: Record<string, ConnectedPosition> = {
    above: {
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'bottom',
      offsetY: -10,
    },
    below: {
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
      offsetY: 10,
    },
    left: {
      originX: 'start',
      originY: 'center',
      overlayX: 'end',
      overlayY: 'center',
      offsetX: -10,
    },
    right: {
      originX: 'end',
      originY: 'center',
      overlayX: 'start',
      overlayY: 'center',
      offsetX: 10,
    },
  };
  return positions[position] || positions.below;
}

export function getPositionClass(pair: ConnectedPosition): string {
  if (pair.originY === 'bottom' && pair.overlayY === 'top') {
    return 'arrow-top';
  }
  if (pair.originY === 'top' && pair.overlayY === 'bottom') {
    return 'arrow-bottom';
  }
  if (pair.originX === 'start' && pair.overlayX === 'end') {
    return 'arrow-right';
  }
  if (pair.originX === 'end' && pair.overlayX === 'start') {
    return 'arrow-left';
  }
  return 'arrow-top';
}
